import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticWeightBoxInput,
    LogisticWeightBox,
    UpdateLogisticWeightBoxInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticWeightBoxService {
    private amplifyClient = generateClient();
    constructor() {}

    async listLogisticWeightBoxes(): Promise<LogisticWeightBox[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticWeightBoxes
                })
            ).data.listLogisticWeightBoxes.items;
            if (data) return data as LogisticWeightBox[];
        } catch (error) {
            console.error('Error finding LogisticWeightBox:', error);
            return null;
        }
    }

    async listAllLogisticWeightBoxes(
        pageLimit: number = 100
    ): Promise<LogisticWeightBox[]> {
        const boxes: LogisticWeightBox[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticWeightBoxes,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticWeightBoxes;
                boxes.push(...((response?.items ?? []) as LogisticWeightBox[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return boxes;
        } catch (error) {
            console.error('Error finding LogisticWeightBox:', error);
            return [];
        }
    }
    async createLogisticWeightBox(
        input: CreateLogisticWeightBoxInput
    ): Promise<LogisticWeightBox> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticWeightBox,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticWeightBox;
            if (date) return date as LogisticWeightBox;
        } catch (error) {
            console.error('Error creating LogisticWeightBox:', error);
            return null;
        }
    }

    async updateLogisticWeightBox(
        input: UpdateLogisticWeightBoxInput
    ): Promise<LogisticWeightBox> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticWeightBox,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticWeightBox;
            if (date) return date as LogisticWeightBox;
        } catch (error) {
            console.error('Error creating LogisticWeightBox:', error);
            return null;
        }
    }
}
